import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import { supabase } from './supabase';
import NumiSync from './NumiSync';
import Auth from './Auth';

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setUser(session?.user ?? null);
      setLoading(false);
    });

    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      setUser(session?.user ?? null);
    });

    return () => subscription.unsubscribe();
  }, []);

  if (loading) {
    return (
      <div style={{
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        height: '100vh', background: '#0a0c0b', color: '#c9a84c',
        fontFamily: 'sans-serif', fontSize: 14
      }}>
        Loading...
      </div>
    );
  }

  return user ? <NumiSync user={user} onSignOut={() => supabase.auth.signOut()} /> : <Auth onAuth={setUser} />;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);